const AuthTypes = {
  APPROVE_REJECT_SHIPMENT_IN_FAIL: 'AUTH_TYPES.APPROVE_REJECT_SHIPMENT_IN_FAIL',
  APPROVE_REJECT_SHIPMENT_IN_PROGRESS: 'AUTH_TYPES.APPROVE_REJECT_SHIPMENT_IN_PROGRESS',
  APPROVE_REJECT_SHIPMENT_IN_SUCCESS: 'AUTH_TYPES.APPROVE_REJECT_SHIPMENT_IN_SUCCESS',

  CHANGE_COMPANY_IN_FAIL: 'AUTH_TYPES.CHANGE_COMPANY_IN_FAIL',
  CHANGE_COMPANY_IN_PROGRESS: 'AUTH_TYPES.CHANGE_COMPANY_IN_PROGRESS',
  CHANGE_COMPANY_IN_SUCCESS: 'AUTH_TYPES.CHANGE_COMPANY_IN_SUCCESS',
  GET_USER_MENU_ERROR: 'AUTH_TYPES.GET_USER_MENU_ERROR',

  GET_USER_MENU_ITEMS_ERROR: 'AUTH_TYPES.GET_USER_MENU_ITEMS_ERROR',
  GET_USER_MENU_ITEMS_PROGRESS: 'AUTH_TYPES.GET_USER_MENU_ITEMS_PROGRESS',
  GET_USER_MENU_ITEMS_SUCCESS: 'AUTH_TYPES.GET_USER_MENU_ITEMS_SUCCESS',
  GET_USER_MENU_PROGRESS: 'AUTH_TYPES.GET_USER_MENU_PROGRESS',
  GET_USER_MENU_SUCCESS: 'AUTH_TYPES.GET_USER_MENU_SUCCESS',

  GET_USER_PREFERENCE_ERROR: 'AUTH_TYPES.GET_USER_PREFERENCE_ERROR',

  GET_USER_PREFERENCE_PROGRESS: 'AUTH_TYPES.GET_USER_PREFERENCE_PROGRESS',
  GET_USER_PREFERENCE_SUCCESS: 'AUTH_TYPES.GET_USER_PREFERENCE_SUCCESS',
  GET_USER_PROFILE_ERROR: 'AUTH_TYPES.GET_USER_PROFILE_ERROR',
  GET_USER_PROFILE_PROGRESS: 'AUTH_TYPES.GET_USER_PROFILE_PROGRESS',
  GET_USER_PROFILE_SUCCESS: 'AUTH_TYPES.GET_USER_PROFILE_SUCCESS',
  LOGIN_IN_SUCCESS: 'AUTH_TYPES.LOGIN_IN_SUCCESS',

  SET_SELECTED_COMPANY: 'AUTH_TYPES.SET_SELECTED_COMPANY',
};

export default AuthTypes;
